export default __webpack_public_path__ + "static/media/GroupTabl.392a6ffe.png";